/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Swiper from "vux/src/components/swiper/swiper.vue"; // this line is trasformed by vux-loader
import SwiperItem from "vux/src/components/swiper/swiper-item.vue"; // this line is trasformed by vux-loader
import ScrollerList from '@/components/ScrollerList';
import ScrollerItem from '@/components/ScrollerList/ScrollerItem';
import { apiservicelist, apibannerlist, getEnterprises } from '@/api';
import { menuMapping } from '@/constant';
export default {
  name: 'ServiceItem',
  props: {
    id: [String, Number],
    service_type_id: [String, Number],
    title: String
  },
  components: {
    ViewBox: ViewBox,
    Swiper: Swiper,
    SwiperItem: SwiperItem,
    ScrollerList: ScrollerList,
    ScrollerItem: ScrollerItem
  },
  data: function data() {
    return {
      menuMapping: menuMapping,
      bannerList: [],
      list: [],
      pageIndex: 0,
      pageSize: 10,
      hasMounted: false,
      codeMap: {
        40019: 1
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user', 'pageReload'])), {}, {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - (2 + 2.6) * fontSize - 130;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_pageReload'])), {}, {
    funNavClick: function funNavClick(item) {
      this.$router.push({
        name: this.menuMapping[item.code],
        params: {
          code: item.code
        }
      });
    },
    loadList: function loadList() {
      var _this = this;
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (reset) {
        this.pageIndex = 0;
        this.$vux.loading.show({
          text: i18n.tc("206")
        });
      }
      return new Promise(function (resolve, reject) {
        apiservicelist({
          service_type_id: _this.service_type_id,
          pageIndex: _this.pageIndex,
          pageSize: _this.pageSize
        }).then(function (res) {
          if (!reset) {
            _this.list = Object.freeze([].concat(_toConsumableArray(_this.list), _toConsumableArray(res.data)));
          } else {
            _this.list = Object.freeze(res.data);
            setTimeout(function () {
              _this.$vux.loading.hide();
            }, 300);
          }
          resolve();
          if (res.data.length < _this.pageSize) {
            setTimeout(function () {
              _this.$refs['serviceList'] && _this.$refs['serviceList'].disablePullup();
            }, 100);
          }
          if (res.data.length === _this.pageSize) {
            setTimeout(function () {
              _this.$refs['serviceList'] && _this.$refs['serviceList'].enablePullup();
            }, 100);
          }
        });
      });
    },
    // 下拉刷新
    onPulldownLoading: function onPulldownLoading() {
      var _this2 = this;
      this.loadList(true).then(function () {
        _this2.$refs['serviceList'] && _this2.$refs['serviceList'].donePulldown();
      });
    },
    // 上拉加载
    onPullupLoading: function onPullupLoading() {
      var _this3 = this;
      this.pageIndex = this.pageIndex + 1;
      this.loadList().then(function () {
        _this3.$refs['serviceList'] && _this3.$refs['serviceList'].donePullup();
      });
    }
  }),
  mounted: function mounted() {
    this.hasMounted = true;
  },
  created: function created() {
    var _this4 = this;
    // banner
    apibannerlist({
      type: 2,
      object_id: this.id
    }).then(function (res) {
      if (res.success) _this4.bannerList = res.data;
    });
    this.loadList(true);
    getEnterprises({
      codes: '40019'
    }).then(function (res) {
      if (res.success) {
        res.data.forEach(function (v) {
          _this4.$set(_this4.codeMap, v.code, v.value);
        });
      }
    });
  }
};